module.exports = __webpack_public_path__ + "img/Alert Icon - white.e7e06d61.svg";